export const FORM_FIELDS = {
  PACKING_SLIP_FORMAT: 'packingSlipFormat',
  PACKING_SLIP_ORDER_ITEMS_BY: 'packingSlipOrderItemsBy',
  PACKING_SLIP_INCLUDE_STORE_LOGO: 'packingSlipIncludeStoreLogo',
  PACKING_SLIP_INCLUDE_ITEM_PRICE: 'packingSlipIncludeItemPrice',
  PACKING_SLIP_INCLUDE_ITEM_SKU: 'packingSlipIncludeItemSku',
  PACKING_SLIP_INCLUDE_SCAN_TO_VIEW_BARCODE: 'packingSlipIncludeScanToViewBarcode',
  PACKING_SLIP_INCLUDE_WAREHOUSE_LOCATION: 'packingSlipIncludeWarehouseLocation',
  PACKING_SLIP_SHOW_DISCOUNTS_AS_LINE_ITEMS: 'packingSlipShowDiscountsAsLineItems',
  PACKING_SLIP_HIDE_ZERO_QUANTITY_ITEMS: 'packingSlipHideZeroQuantityItems',
};
